import { WeekdayPeriod } from "@snubes/snubes-types";
import { toLocaleWeekday } from "./toLocaleWeekday";

export function toLocaleWeekdayPeriod(weekdayPeriod: WeekdayPeriod) {
  return `${toLocaleWeekday(weekdayPeriod.weekday)}: ${weekdayPeriod.from} - ${
    weekdayPeriod.to
  }`;
}
